import { z } from 'zod';

export const webhookResponseSchema = {
  200: z.object({ result: z.enum(['success', 'failed', 'skipped']), message: z.string().optional() }),
  500: z.object({ result: z.literal('failed'), message: z.string().optional() }),
};

export type WebhookResponse = {
  200: z.infer<(typeof webhookResponseSchema)[200]>;
  500: z.infer<(typeof webhookResponseSchema)[500]>;
};
